var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconPlayLarge = function SvgIconPlayLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 22,
    viewBox: "0 0 35 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-202 -621)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 22,
    rx: 4,
    transform: "translate(202 621)",
    fill: "#017cba",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.575,29.461V22.953l5.252,3.254Zm7.036-3.774L23.26,21.132A.887.887,0,0,0,22.791,21a.731.731,0,0,0-.791.652v9.111a.731.731,0,0,0,.791.652.886.886,0,0,0,.469-.132l7.351-4.555A.588.588,0,0,0,30.611,25.686Z",
    transform: "translate(193.786 605.737)",
    fill: "var(--main-color-text)"
  }))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNSIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDM1IDIyIj4NCiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAyIC02MjEpIj4NCiAgICAgICAgPHJlY3QgIHdpZHRoPSIzNSIgaGVpZ2h0PSIyMiIgcng9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMiA2MjEpIiBmaWxsPSIjMDE3Y2JhIiBvcGFjaXR5PSIwLjciLz4NCiAgICAgICAgPHBhdGggIGQ9Ik0yMy41NzUsMjkuNDYxVjIyLjk1M2w1LjI1MiwzLjI1NFptNy4wMzYtMy43NzRMMjMuMjYsMjEuMTMyQS44ODcuODg3LDAsMCwwLDIyLjc5MSwyMWEuNzMxLjczMSwwLDAsMC0uNzkxLjY1MnY5LjExMWEuNzMxLjczMSwwLDAsMCwuNzkxLjY1Mi44ODYuODg2LDAsMCwwLC40NjktLjEzMmw3LjM1MS00LjU1NUEuNTg4LjU4OCwwLDAsMCwzMC42MTEsMjUuNjg2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkzLjc4NiA2MDUuNzM3KSIgZmlsbD0idmFyKC0tbWFpbi1jb2xvci10ZXh0KSIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K";
export { SvgIconPlayLarge as ReactComponent };